<template>
  <a-radio-group
      v-if="tagType=='radio'"
      :value="getValueSting"
      :disabled="disabled"
      @change="handleInput"
  >
    <a-radio v-for="(item, key) in dictOptions" :key="key" :value="item.value">{{ item.text }}</a-radio>
  </a-radio-group>

  <a-radio-group
      v-else-if="tagType=='radioButton'"
      buttonStyle="solid"
      :value="getValueSting"
      :disabled="disabled"
      @change="handleInput"
  >
    <a-radio-button v-for="(item, key) in dictOptions" :key="key" :value="item.value">{{ item.text }}</a-radio-button>
  </a-radio-group>

  <a-select
      v-else-if="tagType=='select'"
      :labelInValue="labelInValue"
      :value='getValueSting'
      :mode="selectMode"
      :placeholder="placeholder"
      :disabled="disabled"
      :allowClear="allowClear"
      @change="handleInput"
      style="width: 100%"
  >
    <a-select-option v-if="!ynShow" value="">请选择</a-select-option>
    <a-select-option v-for="(item,index) in dictOptions" :key="index" :value="item.value" @click='changeItem(item)'>
      {{ item.text || item.label }}
    </a-select-option>
  </a-select>
</template>

<script>
import { ajaxGetDictItems, ajaxGetDictItemsForUrl, getDictItemsFromCache } from '@/api/api'
import Vue from 'vue'

export default {
  name: 'JDictSelectTag',
  props: {
    dictCode: String,
    url: String,
    queryParam: Object,
    placeholder: String,
    triggerChange: Boolean,
    disabled: Boolean,
    value: [String, Number, Object, Array],
    type: String,
    getPopupContainer: {
      type: Function,
      default: (node) => node.parentNode
    },
    labelInValue: Boolean,
    selectMode: String,
    ynShow: false,
    allowClear: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dictOptions: [],
      tagType: ''
    }
  },
  watch: {
    dictCode: {
      immediate: true,
      handler() {
        this.initDictData()
      }
    },
    url: {
      immediate: true,
      handler() {
        this.initDictData()
      }
    },
    queryParam: {
      immediate: true,
      handler() {
        this.initDictData()
      }
    }
  },
  created() {
    if (!this.type || this.type === 'list') {
      this.tagType = 'select'
    } else {
      this.tagType = this.type
    }
  },
  computed: {
    getValueSting() {
      return this.value != null ? ((typeof this.value) !== 'object' ? this.value.toString() : this.value) : undefined
    }
  },
  methods: {
    initDictData() {
      if (this.url) {
        ajaxGetDictItemsForUrl(this.url).then((res) => {
          if (res.success) {
            if (res.result.records) {
              this.dictOptions = res.result.records
              return
            }
            this.dictOptions = res.result
          }
        })
      } else if (getDictItemsFromCache(this.dictCode)) {
        this.dictOptions = getDictItemsFromCache(this.dictCode)
      } else if (this.dictCode) {
        // 根据字典Code, 初始化字典数组
        ajaxGetDictItems(this.dictCode, null).then((res) => {
          if (res.success) {
            if (res.result.records && res.result.records.length > 0) {
              Vue.ls.set('cache_dict_data:' + this.dictCode, res.result.records)
              this.dictOptions = res.result.records
            } else if (res.result && res.result.length > 0) {
              Vue.ls.set('cache_dict_data:' + this.dictCode, res.result)
              this.dictOptions = res.result
            }
          } else {
            this.dictOptions = []
          }
        })
      }
    },
    handleInput(e) {
      let val
      if (this.tagType === 'radio') {
        val = e.target.value
      } else {
        val = e
      }
      if (this.triggerChange) {
        this.$emit('change', val)
      } else {
        this.$emit('input', val)
      }
      this.$emit('change', val)
    },
    changeItem(item) {
      this.$emit('changeValue', item)
    },
    setCurrentDictOptions(dictOptions) {
      this.dictOptions = dictOptions
    },
    getCurrentDictOptions() {
      return this.dictOptions
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dict/JDictSelectTag.vue